import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';
import { Configuration, PayoutList, PayoutCommerceList, PayoutCommerceConfiguration, PayoutConfiguration, ResponseExportTemplate, BatchImportPayoutProcess, CreatePayoutProcessBatch, PayoutDetails, PayloadPayoutToConfirm, InvoiceListFromPayout, IPayoutDetail } from '../_models';
import { catchError } from 'rxjs/operators';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { ImportFileOptions } from '../sharedcomp/constans/importProcess.constans';

@Injectable({
  providedIn: 'root'
})

export class PayoutService {
  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  protected kcmssvcURL = this._kcmssvcURL;
  httpOptions: any;
  public defaultHeaders = new HttpHeaders();
  constructor(private http: HttpClient) { }

  getPayoutProcessList(publicId: string, status: string, from_date?: string, to_date?: string, limit?: number, start?: number, search?: string): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling get  Operation Payout List.');
    }
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (status !== undefined && status !== null && status.toString() !== '') {
      queryParameters = queryParameters.set('status', <any>status);
    }

    if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
      queryParameters = queryParameters.set('from_date', <any>from_date);
    }
    if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
      queryParameters = queryParameters.set('to_date', <any>to_date);
    }
    if (limit !== undefined && limit !== null && limit.toString() !== '') {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (start !== undefined && start !== null && start.toString() !== '') {
      queryParameters = queryParameters.set('start', <any>start);
    }
    if (search !== undefined && search !== null && search !== '') {
      queryParameters = queryParameters.set('search', <any>search);
    }

    return this.http.get<Array<PayoutList>>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payout_process`,
      {
        params: queryParameters,
        withCredentials: null,
        observe: 'body',
        reportProgress: false
      })
      .pipe(map(response => response));
  }

  getCustomerPayoutProcessListProcessed(publicId: string, status: string, from_date?: string, to_date?: string, limit?: number, start?: number, search?: string): Observable<PayoutCommerceList> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling get customer payout process list processed');
    }
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (status !== undefined && status !== null && status.toString() !== '') {
      queryParameters = queryParameters.set('status', <any>status);
    }

    if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
      queryParameters = queryParameters.set('from_date', <any>from_date);
    }
    if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
      queryParameters = queryParameters.set('to_date', <any>to_date);
    }
    if (limit !== undefined && limit !== null && limit.toString() !== '') {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (start !== undefined && start !== null && start.toString() !== '') {
      queryParameters = queryParameters.set('start', <any>start);
    }
    if (search !== undefined && search !== null && search !== '') {
      queryParameters = queryParameters.set('search', <any>search);
    }

    return this.http.get<PayoutCommerceList>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payout_process/processed`,
      {
        params: queryParameters,
        withCredentials: null,
        observe: 'body',
        reportProgress: false
      })
      .pipe(map(response => response));
  }

  getAccountDetailsForPayout(publicId: string): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling getAccountDetailsForPayout.');
    }
    return this.http.get(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/accounts?type=(106)`)
      .pipe(map(response => response));
  }

  getPayoutProcessDetails(publicId: string): Observable<PayoutDetails> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling getPayoutProcessDetails.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    return this.http.get<PayoutDetails>(`${this._kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}`, {
      params: queryParameters
    }).pipe(map(response => response));
  }

  getInvoiceListFromPayout(publicId: string, limit: number, start: number, status: string): Observable<InvoiceListFromPayout> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling getInvoiceListFromPayout.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (limit != null && limit.toString() !== '') {
      const limitValue = limit.toString();
      queryParameters = queryParameters.set('limit', <string>limitValue);
    }

    if (start != null && start.toString() !== '') {
      const startValue = start.toString();
      queryParameters = queryParameters.set('start', <string>startValue);
    }

    if (status != null && status !== '') {
      queryParameters = queryParameters.set('status', <string>status);
    }

    return this.http.get<InvoiceListFromPayout>(`${this._kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/invoice_list`, {
      params: queryParameters
    }).pipe(map(response => response));
  }

  downloadPSPFile(publicId: string, template: string): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling getPSPExportExcel.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let body = { "export_template": template };

    return this.http.post(`${this.kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/export`, body,
      {
        observe: 'response',
        headers: headers
      }
    );
  }

  rejectInvoice(publicId: string, description: string): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling rejectInvoice.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let body = {
      "invoice_id": publicId,
      "description": description
    };
    return this.http.post(`${this.kcmssvcURL}/invoices/${encodeURIComponent(String(publicId))}/payout_reject`, body,
      {
        observe: 'response',
        headers: headers
      }
    );
  }

  createPayoutProcess(body: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(`${this.kcmssvcURL}/payout_process`, body,
      {
        observe: 'response',
        headers: headers
      }
    );
  }

  executePayoutProcess(publicId: string, body: any): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling executePayoutProcess.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(`${this.kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/execute`, body,
      {
        observe: 'response',
        headers: headers
      }
    ).pipe(catchError(this.formatErrors));;
  }

  cancelPayoutProcess(publicId: string) {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling cancelPayoutProcess.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(`${this.kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/cancel`, {},
      {
        observe: 'response',
        headers: headers
      }
    )
  }

  downloadfile(url: string) {
    const headers = new HttpHeaders().set("InterceptorSkipHeader", 'Yes').set('Content-Type', 'application/pdf');
    return this.http.get(url,
      {
        headers: headers,
        responseType: 'blob',
        observe: 'response'
      });
  }

  downloadFile(publicId: string, template: string): Observable<any> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling download file.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let body = { "export_template": template };

    return this.http.post(`${this.kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/export`, body,
      {
        observe: 'response',
        headers: headers
      }
    );
  }

  downloadFilePayout(publicId: string, payoutId: string, template: string) {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling download file.');
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let body = { "export_template": template };

    return this.http.post<ResponseExportTemplate>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payout_process/${payoutId}/export`, body,
      {
        observe: 'response',
        headers: headers
      }
    );
  }

  getPayoutConfiguration(publicId: string): Observable<Configuration> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling the payout configuration details.');
    }
    return this.http.get(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payout_process.properties`)
      .pipe(map(response => response));
  }

  getPayoutServiceConfiguration(publicId: string): Observable<PayoutConfiguration> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling the payout configuration details.');
    }
    return this.http.get<PayoutConfiguration>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payout_services.properties`)
      .pipe(map(response => response));
  }

  getPayoutServiceOpsConfiguration(publicId: string): Observable<PayoutCommerceConfiguration> {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling the payout configuration details.');
    }
    return this.http.get<PayoutCommerceConfiguration>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payout_services_ops.properties`)
      .pipe(map(response => response));
  }

  confirmOperations(publicId: string, body: FormData) {
    return this.http.post(`${this.kcmssvcURL}/payout_process/${encodeURIComponent(String(publicId))}/confirm`, body,
      {
        observe: 'response',
      }
    );
  }

  createBatch(body: any, observe: any = 'body', reportProgress: boolean = false): Observable<HttpResponse<CreatePayoutProcessBatch>> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling  Payout Process Import.');
    }
    let headers = this.defaultHeaders;

    headers.append('Content-Type', 'text/plain');

    return this.http.post<CreatePayoutProcessBatch>(`${this.kcmssvcURL}/payout_process/batch`,
      body,
      {
        observe: 'response'
        , headers: headers

      }
    );

  }//end

  processBatch(public_id: string, url: string = 'payout_process'): Observable<BatchImportPayoutProcess> {
    if (public_id === null || public_id === undefined) {
      throw new Error('Required parameter public_id was null or undefined when calling  Payout Process Import.');
    }
    let headers = this.defaultHeaders;

    headers.append('Content-Type', 'text/plain');

    return this.http.post<BatchImportPayoutProcess>(`${this.kcmssvcURL}/${url}/batch/${public_id}`,
      {
        observe: 'response'
        , headers: headers

      }
    );

  }//end

  private formatErrors(error: any) {
    return throwError(error);
  }

  getPayoutDetailAvalibleBalance(currency: string): Observable<IPayoutDetail> {
    return this.http.get<IPayoutDetail>(`${this.kcmssvcURL}/payouts/account?currency=${currency}`);
  }

  confirmInstaPayout(public_id: string): Observable<any> {
    return this.http.post<any>(`${this.kcmssvcURL}/payouts/${public_id}/confirm`, null);
  }

  porcentageInstaPyo(publicId: string): Observable<Configuration> {
    return this.http.get(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/dispersion_percentage.configuration`)
  }
}
